/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `make_gridadmin` - make_gridadmin
 * * `make_tables` - make_tables
 * * `make_cog` - make_cog
 * * `make_geojson` - make_geojson
 * * `make_simulation_templates` - make_simulation_templates
 * * `inherit_simulation_templates` - inherit_simulation_template
 * * `make_aggregations` - make_aggregations
 * @export
 */
export const ThreediModelTaskNameEnum = {
  MAKE_GRIDADMIN: "make_gridadmin",
  MAKE_TABLES: "make_tables",
  MAKE_COG: "make_cog",
  MAKE_GEOJSON: "make_geojson",
  MAKE_SIMULATION_TEMPLATES: "make_simulation_templates",
  INHERIT_SIMULATION_TEMPLATES: "inherit_simulation_templates",
  MAKE_AGGREGATIONS: "make_aggregations",
} as const;
export type ThreediModelTaskNameEnum =
  (typeof ThreediModelTaskNameEnum)[keyof typeof ThreediModelTaskNameEnum];

export function instanceOfThreediModelTaskNameEnum(value: any): boolean {
  for (const key in ThreediModelTaskNameEnum) {
    if (Object.prototype.hasOwnProperty.call(ThreediModelTaskNameEnum, key)) {
      if (ThreediModelTaskNameEnum[key as keyof typeof ThreediModelTaskNameEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ThreediModelTaskNameEnumFromJSON(json: any): ThreediModelTaskNameEnum {
  return ThreediModelTaskNameEnumFromJSONTyped(json, false);
}

export function ThreediModelTaskNameEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ThreediModelTaskNameEnum {
  return json as ThreediModelTaskNameEnum;
}

export function ThreediModelTaskNameEnumToJSON(value?: ThreediModelTaskNameEnum | null): any {
  return value as any;
}

export function ThreediModelTaskNameEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): ThreediModelTaskNameEnum {
  return value as ThreediModelTaskNameEnum;
}
